import Tippy from "@tippyjs/react";
import React, { useEffect, useState } from "react";

import "./styles.css";

const AiReviewToolTip = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Tippy content={tooltipContent} interactive={true} trigger={isMobile ? "click" : "mouseenter focus"} placement="bottom" theme="light-custom">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.4 3H6.6V4.2H5.4V3ZM5.4 5.4H6.6V9H5.4V5.4ZM6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6 10.8C3.354 10.8 1.2 8.646 1.2 6C1.2 3.354 3.354 1.2 6 1.2C8.646 1.2 10.8 3.354 10.8 6C10.8 8.646 8.646 10.8 6 10.8Z"
            fill="#8C8C8C"
          />
        </svg>
      </div>
    </Tippy>
  );
};

export default AiReviewToolTip;

const tooltipContent = (
  <div className="ai-tooltip-box">
    <h3>About Ai Summaries</h3>
    <p>
      This rating is AI-generated based on user reviews from publicly available information. We analyze and scale the feedback to a 5-point system to
      provide a general impression. It may not reflect recent experiences, so we recommend checking individual reviews for more detailed insights.
    </p>
  </div>
);
